module.exports = __webpack_public_path__ + "static/candu_logo-50eb191665616a32868e32ce48fb3c94.svg";